export class CompanyModel {
  userCompanyId: string;
  companyId: string;
  companyName: string;
  isActive: boolean;
  accessToAllJobs: boolean;
}
